<template>
  <custom-dialog width="460px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body message-item-bd">
      <div class="content">
        <h2>{{model.data.title}}</h2>
        <p>{{model.data.content}}</p>
      </div>
      <div class="timer">
        <i class="icon icon-shijian"></i>
        {{ momentAmPm($momentLocal(model.data.sendTime)) }}
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveIndicator">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    // 确认保存菜单
    saveIndicator: function () {
      const ids = [this.model.data.messageId];
      this.$postJSON(apis.msgRecordRead, ids).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.visible = false;
        // 更新
        this.$$emit('success');
      });
    }
  }
};
</script>

<style lang="scss">
.message-item-bd {
  .content {
    padding: 16px 16px 40px;
    h2 {
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 22px;
      margin-bottom: 16px;
    }
    p {
      font-size: 12px;
      color: rgba(108, 117, 125, 1);
      line-height: 21px;
    }
  }
  .timer {
    font-size: 12px;
    color: rgba(108, 117, 125, 1);
    line-height: 28px;
  }
}
</style>
